import TextFieldControl from "components/form/TextFieldControl";
import VALIDATION from "helpers/validation";
import AvailableRangeControl from "../../components/AvailableRangeControl";
import InterviewSwitch from "../../components/InterviewSwitch";
import ReportSwitch from "../../components/ReportSwitch";

interface GroupAndOpenLeftProps {
  isCreate: boolean;
  isEditing: boolean;
}

const GroupAndOpenLeft = ({ isCreate, isEditing }: GroupAndOpenLeftProps) => {
  return (
    <>
      <InterviewSwitch />
      <ReportSwitch />
      <TextFieldControl
        name='title'
        label='Название тестирования'
        rules={{ ...VALIDATION.competencyMapTitle }}
        disabled={!isCreate}
      />
      <TextFieldControl
        name='createdAt'
        label='Дата создания тестирования'
        disabled
      />
      <AvailableRangeControl disabled={!isEditing} />
    </>
  );
};

export default GroupAndOpenLeft;
